import { useEffect } from 'react';
import { useLang } from '../../../../../../hooks/use-lang';
import { useQueryParams } from '../../../../../../hooks/use-query-params';
import { getMenuId } from '../../menu-informer/menu-informer-helpers';
import { useIikoStore } from '../../../../../../store/use-iiko-store';

export const useMenuIikoSlider = () => {
  const { getLocale, t } = useLang();
  const {
    isLoading,
    fetchMenuList,
    fetchMenu,
    list = [],
    setIikoMenuListOrder,
    fetchTerminalList,
  } = useIikoStore();
  const { getQueryParams, addQueryParams } = useQueryParams();
  const params = getQueryParams();
  const menuId = getMenuId();
  const branchId = params.branchId;

  useEffect(() => {
    fetchMenuList({ branch_id: branchId });
    if (!branchId) return;
    fetchTerminalList({ branch_id: branchId });
  }, [branchId]);

  useEffect(() => {
    if (!menuId) return;
    fetchMenu(menuId);
  }, [menuId]);

  useEffect(() => {
    const selected = list.find((item) => item.id === menuId);
    if (selected?.place_id && !branchId) {
      fetchTerminalList({ branch_id: String(selected.place_id) });
    }
  }, [list, branchId, menuId]);

  const isRenderSlider = !!list?.length;

  return {
    getLocale,
    isLoading,
    menuList: list,
    menuId,
    t,
    isRenderSlider,
    addQueryParams,
    setIikoMenuListOrder,
  };
};
